// TSS vite/03 §"Query keys convention".
// Tuples, entity name first, scope narrowing rightward.
// Centralizing them here is what lets invalidation target one slice.

export const clientKeys = {
    all:    ['clients'],
    list:   (params) => ['clients', 'list', params],
    detail: (id)     => ['clients', 'detail', id],
};
